var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notifications"},[_c('transition-group',{attrs:{"name":"slide"}},_vm._l((_vm.notifications),function(notification){return _c('NotificationsElement',{key:notification.id,attrs:{"notification":notification}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }